export default __webpack_public_path__ + "static/media/img_shixiao.791cf19a.png";